import { ModuleWithProviders, NgModule, signal } from '@angular/core';
import { Store, StoreModule } from '@softline/core';
import { SOFTLINE_FEATURE_SHELL } from '@softline/application';
import { SOFTLINE_FEATURE_TRANSLATION, SOFTLINE_MASTER_DETAIL_HEIGHT, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import * as ShellStore from './shell/shell.store';
import { userProviders } from './user/user.providers';

@NgModule({
  declarations: [],
  imports: [],
  providers: [],
  exports: [],
})
export class SoftappsCoreModule {
  static forRoot(): ModuleWithProviders<SoftappsCoreRootModule> {
    return {
      ngModule: SoftappsCoreRootModule,
      providers: [
        { provide: SOFTLINE_MASTER_DETAIL_HEIGHT, useFactory: () => signal(null) },
      ],
    };
  }
}

@NgModule({
  imports: [
    SoftappsCoreModule,
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_SHELL,
      feature: ShellStore.feature,
    }),],
  exports: [SoftappsCoreModule],
  providers: [
    ...userProviders
  ],
})
export class SoftappsCoreRootModule {
  constructor(store: Store) {
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'softapps-core',
      language: 'de',
      translations: de,
    });
  }
}
